export const FeatureFlags = {
  ACTIVE_SESSIONS: 'fe.active-sessions',
} as const;
